import log from '../../lib/salvo-lite/log'

class NewsletterPopup {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._closeElems = this._elem.querySelectorAll('[data-close]')
        this._newsletterKey = 'ESC_NEWSLETTER_CLOSED'
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)

        if (!localStorage.getItem(this._newsletterKey)) {
            this._elem.classList.add('shown')
        }

        for (let closeElem of this._closeElems) {
            closeElem.addEventListener('click', (e) => {
                e.preventDefault()
                localStorage.setItem(this._newsletterKey, true)
                this._elem.classList.remove('shown')
            })
        }

        this._elem.addEventListener('click', (e) => {
            if (e.target === this._elem) {
                e.preventDefault()
                localStorage.setItem(this._newsletterKey, true)
                this._elem.classList.remove('shown')
            }
        })

        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default NewsletterPopup



// WEBPACK FOOTER //
// ./resources/scripts/components/NewsletterPopup.js